import * as React from 'react';
import cn from 'classnames';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';
import * as Styles from '../Icon.module.scss';

export const NavigationPointerFilledIcon = ({ fill = 'offBlack', size = 'small', className }: IconProps) => {
    const fillStyles = cn(fill && Styles[fill], Styles.fill);

    return (
        <svg
            data-testid="navigation-pointer-filled-icon"
            xmlns="http://www.w3.org/2000/svg"
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 21 21"
            fill="none"
            className={className}
        >
            <path
                d="M19.0571 0.0630402C18.684 -0.0615846 18.3367 0.0285402 18.1641 0.0786965C17.9759 0.133357 17.7516 0.220919 17.5266 0.30877L1.54289 6.54632C1.29137 6.64444 1.04776 6.73947 0.859737 6.83244C0.697274 6.91277 0.351964 7.09156 0.159216 7.46258C-0.0533427 7.87173 -0.0530562 8.35881 0.159983 8.76771C0.353168 9.1385 0.698687 9.31689 0.861245 9.39703C1.04937 9.48977 1.29306 9.58451 1.54468 9.68232L7.87074 12.1424L10.3308 18.4684C10.4287 18.7201 10.5234 18.9638 10.6162 19.1519C10.6963 19.3145 10.8747 19.66 11.2455 19.8532C11.6544 20.0662 12.1415 20.0665 12.5506 19.854C12.9216 19.6612 13.1004 19.3159 13.1807 19.1534C13.2737 18.9654 13.3687 18.7218 13.4668 18.4703L19.7044 2.48656C19.7923 2.26156 19.8798 2.03729 19.9345 1.84912C19.9846 1.67645 20.0748 1.32914 19.9501 0.956085C19.8093 0.534605 19.4786 0.203843 19.0571 0.0630402Z"
                className={fillStyles}
            />
        </svg>
    );
};
